import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-movetoFileManager',
  templateUrl: './renameFileManager.component.html',
  styleUrls: ['./renameFileManager.component.scss'] 
})

export class RenameFileManagerComponent implements OnInit {
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;


  formDialog: FormGroup;   
  MyDrivefoldersList:any;
  activeNodeFileManager:string="";
  menuHeaderMyDrive: any = [];
  FileManagerFolderListLeft:any;
  selectButtonMyDriveShow:boolean=false;
  foldersMyDriveListShow:boolean=false;
  hierarchyList: any;
  fileManagerID:string="";
  disableRename:boolean=true;
  isFile:boolean=false;
FileFolderName:string="";

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID:node.fileManagerItemID,
      parentID:node.parentID,
      level: level,
    };
  }
  
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  parentIdTomove:number;
  fileManagerItemTobeMoved:number;
  newParentFolderSelected: any;
  constructor( private _dataSharingService: DataSharingService,private dialog: MatDialog,
    public dialogRef: MatDialogRef<RenameFileManagerComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,
    private settingsService: SettingService,
    private statusConst: StatusConstant,
    private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    this.parentIdTomove = 0;
    this.fileManagerItemTobeMoved = data.fileManagerItemID.fileManagerItemID;
    this.isFile = data.fileManagerItemID.isFile;
    if(this.isFile ==true){
      this.FileFolderName ="File Name";
    }else{
      this.FileFolderName ="Folder Name";
    }
  }  
  
  ngOnInit(): void {  
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('formFolderName', this.formBuilder.control(''));   
    this.setFormVal();
  }  

  setFormVal(){
    this.formDialog.setValue({"formFolderName":this.data.fileManagerItemID.name});
  }

  spinner:boolean=false;
  renameFileManagerItem(data){
    this.spinner=true;
    this.disableRename=true;
    let reqModel = {
              fileManagerItemID:Number(this.fileManagerItemTobeMoved),
              nameToUpdate:data.formFolderName.trim(),
              userID:this.currentUser.UID,
              organizationID:Number(this.organizationId),
              databaseID:Number(this.databaseId)
            }   
    this.settingsService.renameFileManagerItems(reqModel).subscribe(response=>{
     if(response.data == true){            
         this.dialogRef.close(data.formFolderName.trim());
         var ReqModel= {
              name:data.formFolderName.trim(),
              fileManagerItemID:this.fileManagerItemTobeMoved
            }
          this._dataSharingService.sendRefreshListForFileManager(true);
          this._dataSharingService.sendRenamedItemForFileManager(ReqModel);
        }

    });
   
  }  

  close() {
     this.dialog.closeAll();
  } 

  onChange(text:any){
    if(text.formFolderName==""){
      this.disableRename=true;
      return this.disableRename;
    }else{
      this.disableRename=false;
      return this.disableRename;
    }
  }
  
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID:number;
  parentID:number;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID:number;
  parentID:number;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID:number;
  parentID:number;
}